import Headerhcm from "./Headerhcm";
import Taisao from "./Taisao";
import Tantam from "./Tantam";
import Quytrinh from "./Quytrinh";
import Danhgia from "./Danhgia";
import Contact from "./Contact";

export default function Hcm() {
    return(
        <div>
            <Headerhcm />
            <Taisao />
            <Tantam />
            <Quytrinh />
            <Danhgia />
            <Contact />
        </div>
    )
}